/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

import StockProfilePic from '../../../../assets/images/mock/StockProfilePic.png'

import './CommunityLeaderboardCard.scss'

const CommunityLeaderboardCard = (props) => {
  const { t } = useTranslation()
  // Use StockProfilePic if student has no profile pic
  let studentPic = StockProfilePic
  if (props.pic && props.pic.file_url) {
    studentPic = props.pic.file_url
  }

  return (
    <div className='comm-leaderboard-card' id={'comm-leaderboard-' + props.ordinal}>
      <div className='comm-leaderboard-card-ordinal'>
        <p>{props.ordinal}</p>
      </div>
      <img
        src={studentPic}
        alt={t('proShop.communityLeaderboardCard.profilePictureOf', { name: props.name })}
        className='comm-leaderboard-card-pic'
      />
      <p className='comm-leaderboard-card-name'>{props.name}</p>
      <p className='comm-leaderboard-card-points'>
        {t('proShop.communityLeaderboardCard.points', { points: props.points.toLocaleString() })}
      </p>
    </div>
  )
}

export default CommunityLeaderboardCard
